import { Image1, Image1Thumb } from "../../assets/images";

const productsDb = [
  {
    id: "1",
    unitNumber: "EX294",
    year: "2012",
    make: "CAT",
    model: "330BL",
    serialNumber: "6DR028592",
    hours: "19490",
    targetSellPrice: "$25000",
    locationName: "OHio Shop",
    advertised: "Yes",
    Image: {
      org: Image1,
      thumb: Image1Thumb,
    },
  },
  {
    id: "2",
    unitNumber: "EX294",
    year: "2011",
    make: "CAT",
    model: "330BL",
    serialNumber: "6DR028592",
    hours: "19490",
    targetSellPrice: "$25000",
    locationName: "OHio Shop",
    advertised: "Yes",
    Image: {
      org: Image1,
      thumb: Image1Thumb,
    },
  },
  {
    id: "3",
    unitNumber: "EX294",
    year: "2012",
    make: "CAT",
    model: "330BL",
    serialNumber: "6DR028592",
    hours: "19490",
    targetSellPrice: "$25000",
    locationName: "OHio Shop",
    advertised: "Yes",
    Image: {
      org: Image1,
      thumb: Image1Thumb,
    },
  },
];

export default productsDb;
